<template>
  <div>
    <a-modal
      :visible="visible"
      wrapClassName="responsive-modal"
      title="买赠设置"
      :confirmLoading="confirmLoading"
      @ok="confirm"
      @cancel="hide()"
      closable
    >
      <div style="width: 100%">
        <Layout style="width: 100%" :showMenu="false" :menuList="menuList" :defaultKeys="[0]" :activeKey.sync="key" :mainImage="true" :mainImageUrl="record.images.length ? record.images[0] : ''" >
          <template slot="content" >
            <div v-show="key === 0" style="height:100%">
              <div class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>
              <tk-flex class="m-b-24">
                <div class="font-14 unshrink" style="color: #363B45">买赠类型：</div>
                <a-radio-group name="radioGroup" v-model="giftType">
                  <a-radio :value="'0'">
                    暂未开启
                  </a-radio>
                  <a-radio :value="'1'">
                    全国买赠
                  </a-radio>
                </a-radio-group>
              </tk-flex>
              <div v-if="giftType === '1'" >
                <tk-flex class="m-b-24">
                  <div class="font-14 unshrink" style="color: #363B45" >买赠主图：</div>
                  <div class="fill">
                    <ak-type-input v-model="mainImage" class="hide-label" :field="mainImageField" style="margin-bottom: 0;width: 100%" />
                    <tk-flex middle class="m-t-15" >
                      <a-icon type="exclamation-circle" theme="filled" style="color: #AFB4BC; fontSize: 15px;" />
                      <div class="font-12 m-l-4" style="color: #808690">
                        上传1张，建议上传尺寸为750x562PX
                      </div>
                    </tk-flex>
                  </div>
                </tk-flex>
                <tk-flex style="width: 100%">
                  <div class="font-14 unshrink" style="color: #363B45" >包含赠品：</div>
                </tk-flex>
                <div class="m-t-10 m-b-24">
                  <!-- <a-button class="editable-add-btn m-b-10" @click="handleAdd">
                    添加
                  </a-button> -->
                  <a-table
                    v-if="device !== 'mobile'"
                    style="width: 100%"
                    :columns="columns"
                    :data-source="data"
                    bordered
                    :pagination="false"
                    :scroll="{x: 600}"
                    size="small"
                  >
                    <div slot="image" slot-scope="text">
                      <viewer v-if="text" :images="[text]">
                        <img :src="text" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                      </viewer>
                      <span v-else> 暂无 </span>
                    </div>
                    <div slot="gift" slot-scope="">
                      <SelectGift placeholder="请选择" :where="where" allowClear showSearch :value.sync="gift" :valueData.sync="giftData" style="width: 100%" ></SelectGift>
                      <!-- <ak-type-input v-model="gift" class="hide-label" :field="giftField" style="margin-bottom: 0;width: 100%" /> -->
                    </div>
                  </a-table>
                  <div v-else>
                    <a-descriptions size="small" bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
                      <a-descriptions-item
                        v-for="( itm, i) in columns" :key="`item${i}`"
                        :label="itm.title"
                      >
                        <div v-if="itm.dataIndex === 'image'">
                          <viewer v-if="item[itm.dataIndex]" :images="[item[itm.dataIndex]]">
                            <img :src="item[itm.dataIndex]" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                          </viewer>
                          <span v-else> 暂无 </span>
                        </div>
                        <div v-else-if="itm.dataIndex === 'gift'">
                          <SelectGift placeholder="请选择" :where="where" allowClear showSearch :value.sync="gift" :valueData.sync="giftData" style="width: 100%" ></SelectGift>
                        </div>
                        <div v-else>{{ item[itm.dataIndex] }}</div>
                      </a-descriptions-item>
                    </a-descriptions>
                  </div>
                </div>

                <tk-flex class="m-b-24">
                  <div class="font-14 unshrink" style="color: #363B45" >截止日期：</div>
                  <div class="fill">
                    <a-date-picker v-model="deadline"  @change="onChange" :disabledDate="disabledDate" />
                    <!-- <ak-type-input v-model="deadline" class="hide-label" :field="deadlineField" style="margin-bottom: 0;width: 100%" /> -->
                  </div>
                </tk-flex>

                <tk-flex>
                  <div class="font-14 unshrink" style="color: #363B45" >是否邮寄：</div>
                  <a-radio-group v-model="pinkage">
                    <a-radio :value="true">
                      是
                    </a-radio>
                    <a-radio :value="false">
                      否
                    </a-radio>
                  </a-radio-group>
                </tk-flex>
              </div>

              <!-- <div v-if="giftType === '2'" >
                <a-button class="editable-add-btn m-b-10" @click="handleAdd">
                  添加
                </a-button>
                <a-table style="width: 100%" :columns="columnsRegion" :data-source="dataRegion" bordered :pagination="false" :scroll="{x: 600}" >
                  <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
                  <div slot="agent" slot-scope="text, data, index">
                    <SelectAgent v-if="data.editable" placeholder="请选择" :value="data.agent" val="nickName" :record="record" allowClear showSearch @change="(e)=> changeAgent(e, index)" style="width: 100%" ></SelectAgent>
                    <span v-else>{{ data.agentData.nickName }}</span>
                  </div>
                  <div class="upLoad" slot="mainImage" slot-scope="text, record">
                    <ak-type-input v-if="record.editable" v-model="record.mainImage" class="hide-label" :field="mainImageField" style="margin-bottom: 0;width: 60px;height: 60px" />
                    <viewer v-else-if="text && !record.editable" :images="[text]">
                      <img :src="text" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                    </viewer>
                    <span v-else> 暂无 </span>
                  </div>
                  <div slot="image" slot-scope="text">
                    <viewer v-if="text" :images="[text]">
                      <img :src="text" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                    </viewer>
                    <span v-else> - </span>
                  </div>
                  <div slot="gift" slot-scope="text, record, index">
                    <SelectGift v-if="record.editable" placeholder="请选择" :value="record.gift" allowClear showSearch @change="(e)=> changeGift(e, index)" style="width: 100%" ></SelectGift>
                    <div v-else>{{ record.giftData.name }}</div>
                  </div>
                  <div slot="pinkage" slot-scope="text, record">
                    <ak-type-input v-if="record.editable" v-model="record.pinkage" class="hide-label" :field="pinkageField" style="margin-bottom: 0;width: 100%" />
                    <span v-else>{{ text ? '是' : '否' }}</span>
                  </div>
                  <div slot="deadline" slot-scope="text, record, index">
                    <a-date-picker v-if="record.editable" v-model="record.deadline" @change="(date, dateString)=>onChangeRegion(date, dateString, index)" :disabledDate="disabledDate" style="width: 100%" />
                    <span v-else>{{ text | day }}</span>
                  </div>

                  <template slot="action" slot-scope="text, record, index">
                    <div class="editable-row-operations">
                      <span v-if="record.editable">
                        <a class="m-r-10" @click="() => save(index)">保存</a>
                        <a-popconfirm title="确定取消吗？" @confirm="() => cancel(index)">
                          <a>取消</a>
                        </a-popconfirm>
                      </span>
                      <span v-else>
                        <a class="m-r-10" :disabled="editingKey !== ''" @click="() => edit(index)">编辑</a>
                        <a-popconfirm title="确定删除吗？" @confirm="() => deleat(index)">
                          <a>删除</a>
                        </a-popconfirm>
                      </span>
                    </div>
                  </template>
                </a-table>
              </div> -->

            </div>
          </template>
        </Layout>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import Layout from '../../components/layout.vue'
import SelectGift from './selectGift.vue'
// import SelectAgent from './selectAgent.vue'
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      confirmLoading: false,
      menuList: [
        {
          name: '买赠设置'
        }
      ],
      key: 0,
      giftType: '0',
      mainImage: '',
      mainImageField: {
        type: 'Image'
      },
      columns: [
        {
          title: '图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '名称',
          dataIndex: 'gift',
          key: 'gift',
          scopedSlots: { customRender: 'gift' },
          width: 300
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '成本价',
          key: 'costPrice',
          dataIndex: 'costPrice',
          scopedSlots: { customRender: 'costPrice' },
          width: 100
        },
        {
          title: '售价',
          key: 'price',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          width: 100
        }
        // {
        //   title: '操作',
        //   key: 'action',
        //   scopedSlots: { customRender: 'action' },
        //   fixed: 'right',
        //   width: 80
        // }
      ],
      data: [
        {
          image: '',
          gift: '',
          number: '1件',
          costPrice: '',
          price: ''
        }
      ],
      gift: '',
      giftData: {},
      giftField: {
        name: 'gift',
        note: '介绍人',
        type: 'Pointer',
        targetClass: 'gift', // 当数据类型为Pointer时必填，指定查询对象
        searchKey: ['name'], // 仅在 Pointer类型下有效，根据输入内容搜索的字段名
        listWhere: (where) => {
          where.isDelete = {
            $ne: true
          }
        }
      },
      pinkage: false,
      deadline: '',
      deadlineField: {
        name: 'deadline',
        type: 'Date',
        disabledDate: (current) => {
          console.log('日期', current)
          // Can not select days before today and today
          return current && current < moment().endOf('day')
        }
      },

      columnsRegion: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          scopedSlots: { customRender: 'index' },
          width: 70
        },
        {
          title: '代理商',
          dataIndex: 'agent',
          key: 'agent',
          scopedSlots: { customRender: 'agent' },
          width: 150
        },
        {
          title: '买赠主图',
          dataIndex: 'mainImage',
          key: 'mainImage',
          scopedSlots: { customRender: 'mainImage' },
          width: 100
        },
        {
          title: '赠品图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '赠品名称',
          dataIndex: 'gift',
          key: 'gift',
          scopedSlots: { customRender: 'gift' },
          width: 150
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '赠品售价',
          key: 'price',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          width: 100
        },
        {
          title: '赠品邮寄',
          key: 'pinkage',
          dataIndex: 'pinkage',
          scopedSlots: { customRender: 'pinkage' },
          width: 120
        },
        {
          title: '截止日期',
          key: 'deadline',
          dataIndex: 'deadline',
          scopedSlots: { customRender: 'deadline' },
          width: 250
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right',
          width: 80
        }
      ],
      dataRegion: [
      ],
      cacheData: [],
      regionObj: {
        objectId: '',
        agent: '',
        agentData: {},
        mainImage: '',
        image: '',
        gift: '',
        giftData: {},
        number: '1件',
        price: '',
        pinkage: false,
        deadline: ''
      },
      editingKey: '',
      agentField: {
        name: 'agent',
        note: '代理商',
        type: 'Pointer',
        targetClass: '_User', // 当数据类型为Pointer时必填，指定查询对象
        searchKey: ['name'], // 仅在 Pointer类型下有效，根据输入内容搜索的字段名
        listWhere: (where) => {
          where.level = '3'
          where.isDelete = {
            $ne: true
          }
        }
      },
      pinkageField: {
        name: 'pinkage',
        type: 'Boolean'
      }

    }
  },
  // 组件
  components: {
    Layout,
    SelectGift
    // SelectAgent
  },
  computed: {
    where () {
      return {
        isDelete: {
          $ne: true
        }
        // isArea: false
      }
    },
    _visible: {
      get () {
        return this.value
      },
      set (v) {
        console.log(v)
        // v-model接收input事件的值来更新value
        this.$emit('update:visible', v)
      }
    }
  },
  watch: {
    gift (val) {
      this.data[0].gift = val
      if (this.giftData && this.giftData.objectId) {
        this.data[0].image = this.giftData.image
        this.data[0].costPrice = this.giftData.costPrice
        this.data[0].price = this.giftData.price
      } else {
        this.data[0].image = ''
        this.data[0].costPrice = ''
        this.data[0].price = ''
      }
    }
  },
  mounted () {
    this.init()
    this.$tkParse.post('/commodity/WWMProductActivity', {
      commodity: this.record.objectId
    })
  },
  methods: {
    // 初始化
    async init () {
      if (this.record) {
        // 深拷贝
        let obj = JSON.parse(JSON.stringify(this.record))
        console.log(obj)
        this.giftType = obj.giftType || '0'
        if (obj.giftType === '1') {
          this.mainImage = obj.mainImage
          this.gift = obj.gift.objectId
          this.giftData = obj.gift
          this.pinkage = obj.pinkage
          this.deadline = obj.deadline
        }
      }
      await this.getGiftRegion()
    },
    disabledDate (current) {
      return current && current < moment().subtract(1, 'days')// 当前日期之前不能选择（不含当前日）
    },
    onChange (date, dateString) {
      this.deadline = dateString
    },
    onChangeRegion (date, dateString, index) {
      this.dataRegion[index].deadline = dateString
    },
    // 选择代理商
    changeAgent (e, i) {
      console.log(e, i)
      let obj = JSON.parse(JSON.stringify(this.dataRegion[i]))
      if (!e) {
        obj.agent = ''
        obj.agentData = {}
      } else {
        obj.agent = e.objectId
        obj.agentData = e
      }
      this.dataRegion.splice(i, 1, obj)
    },
    // 选择赠品
    changeGift (e, i) {
      let obj = JSON.parse(JSON.stringify(this.dataRegion[i]))
      console.log(e, i)
      if (!e) {
        obj.gift = ''
        obj.image = ''
        obj.costPrice = ''
        obj.price = ''
        obj.giftData = {}
      } else {
        obj.gift = e.objectId
        obj.image = e.image
        obj.costPrice = e.costPrice
        obj.price = e.price
        obj.giftData = e
      }
      this.dataRegion.splice(i, 1, obj)
      console.log(this.dataRegion)
    },
    // 添加
    handleAdd () {
      let obj = JSON.parse(JSON.stringify(this.regionObj))
      obj.editable = true
      this.dataRegion.push(obj)
    },
    // 编辑
    edit (index) {
      console.log(index)
      const newData = [...this.dataRegion]
      const target = newData[index]
      this.editingKey = index
      if (target) {
        target.editable = true
        this.dataRegion = newData
      }
    },
    // 保存
    async save (index) {
      try {
        console.log(index)
        const newData = [...this.dataRegion]
        const newCacheData = [...this.cacheData]
        // const target = newData.find(item => key === item.key)
        const target = newData[index]
        console.log(target)
        // 判断代理商 主图 赠品 是否邮寄 截止日期 是否为空
        if (!target.agent) {
          this.$notification['warning']({
            message: '警告',
            description: '代理商不能为空'
          })
          return
        }
        if (!target.mainImage) {
          this.$notification['warning']({
            message: '警告',
            description: '主图不能为空'
          })
          return
        }
        if (!target.gift) {
          this.$notification['warning']({
            message: '警告',
            description: '赠品不能为空'
          })
          return
        }
        // console.log(target.pinkage)
        // if (!target.pinkage) {
        //   this.$notification['warning']({
        //     message: '警告',
        //     description: '是否邮寄不能为空'
        //   })
        //   return
        // }
        if (!target.deadline) {
          this.$notification['warning']({
            message: '警告',
            description: '截止日期不能为空'
          })
          return
        }

        const { data } = await this.$tkParse.get('/classes/winWinMerchantProduct', {
          params: {
            where: {
              commodity: this.record.objectId,
              winWinMerchant: target.agent,
              isDelete: {
                $ne: true
              }
            },
            limit: 1,
            order: '-createdAt'
          }
        })
        await this.$tkParse.put(`/classes/winWinMerchantProduct/${data.results[0].objectId}`, {
          gift: target.gift,
          mainImage: target.mainImage,
          pinkage: target.pinkage,
          deadline: new Date(new Date(target.deadline).setHours(23, 59, 59, 999)).toISOString()
        })

        // const targetCache = newCacheData.find(item => key === item.key)
        const targetCache = newCacheData[index] || {}
        console.log(targetCache)
        if (target) {
          delete target.editable
          this.dataRegion = newData
          Object.assign(targetCache, target)
          this.cacheData = newCacheData
        }
        this.editingKey = ''
        // this.$notification['success']({
        //   message: '成功',
        //   description: '保存成功'
        // })
      } catch (error) {
        console.log(error)
      }
    },
    // 取消
    cancel (index) {
      const newData = [...this.dataRegion]
      // const target = newData.find(item => key === item.key)
      const target = newData[index]
      this.editingKey = ''
      if (target) {
        console.log(this.cacheData[index])
        // Object.assign(target, this.cacheData.find(item => key === item.key))
        if (this.cacheData[index]) {
          Object.assign(target, this.cacheData[index])
          delete target.editable
        } else {
          newData.splice(index, 1)
        }
        this.dataRegion = newData
      }
    },
    async deleat (index) {
      const newData = [...this.dataRegion]
      const newCacheData = [...this.cacheData]
      // const target = newData.find(item => key === item.key)
      const target = newData[index]
      const { data } = await this.$tkParse.get('/classes/winWinMerchantProduct', {
        params: {
          where: {
            commodity: this.record.objectId,
            winWinMerchant: target.agent,
            isDelete: {
              $ne: true
            }
          },
          limit: 1,
          order: '-createdAt'
        }
      })
      await this.$tkParse.put(`/classes/winWinMerchantProduct/${data.results[0].objectId}`, {
        gift: null,
        mainImage: null,
        pinkage: null,
        deadline: null
      })

      // 删除当前数据
      newData.splice(index, 1)
      newCacheData.splice(index, 1)
      this.dataRegion = newData
      this.cacheData = newCacheData

      this.$tkParse.post('/commodity/WWMProductActivity', {
        commodity: this.record.objectId
      })

      this.$notification['success']({
        message: '成功',
        description: '删除成功'
      })
    },
    async confirm () {
      this.confirmLoading = true

      try {
        if (this.giftType === '1') {
          // 判断mainImage gift deadline pinkage 是否为空
          if (!this.mainImage) {
            this.$notification['warning']({
              message: '警告',
              description: '主图不能为空'
            })
            this.confirmLoading = false
            return
          }
          if (!this.gift) {
            this.$notification['warning']({
              message: '警告',
              description: '赠品不能为空'
            })
            this.confirmLoading = false
            return
          }
          // if (!this.pinkage) {
          //   this.$notification['warning']({
          //     message: '警告',
          //     description: '是否邮寄不能为空'
          //   })
          //   this.confirmLoading = false
          //   return
          // }
          if (!this.deadline) {
            this.$notification['warning']({
              message: '警告',
              description: '截止日期不能为空'
            })
            this.confirmLoading = false
            return
          }
          await this.$tkParse.put(`/classes/commodity/${this.record.objectId}`, {
            gift: this.gift,
            mainImage: this.mainImage,
            pinkage: this.pinkage,
            deadline: new Date(moment(this.deadline).endOf('day').format('YYYY-MM-DD HH:mm:ss')).toISOString(),
            giftType: '1'
          })
        }
        // if (this.giftType === '2') {
        //   console.log(this.dataRegion)
        //   // 循环判断dataRegion  如果editable为true  则提示
        //   for (let i = 0; i < this.dataRegion.length; i++) {
        //     if (this.dataRegion[i].editable) {
        //       this.$notification['warning']({
        //         message: '警告',
        //         description: '请先保存数据'
        //       })
        //       this.confirmLoading = false
        //       return
        //     }
        //   }
        //   // 长度为0  提示
        //   if (this.dataRegion.length === 0) {
        //     this.$notification['warning']({
        //       message: '警告',
        //       description: '请先添加数据'
        //     })
        //     this.confirmLoading = false
        //     return
        //   }
        // }
        if (this.giftType !== '1') {
          await this.$tkParse.put(`/classes/commodity/${this.record.objectId}`, {
            gift: null,
            mainImage: null,
            pinkage: null,
            deadline: null,
            giftType: this.giftType
          })
        }

        // 不管未开始 还是 全国， 全部取消代理商活动
        await this.$tkParse.post('/commodity/cancelWWMProduct', {
          commodity: this.record.objectId
        })

        // this.vm.$refs.management.$refs.table.refresh()
        this.vm.refreshGift() // 数据更新后，你可能需要刷新modelTable
        this.$emit('complete') // 触发complete事件，会自动关闭该组件
        this.vm.showGift = false
      } catch (e) {
        console.log('错误', e)
        this.confirmLoading = false
        this.$notification['error']({
          message: '错误',
          description: '添加失败'
        })
      }
    },
    hide () {
      this.vm.refreshGift() // 数据更新后，你可能需要刷新modelTable
      this.vm.showGift = false
    },
    async getGiftRegion () {
      let { data: res } = await this.$tkParse.get('/classes/winWinMerchantProduct', {
        params: {
          include: 'winWinMerchant,gift',
          limit: 1000,
          where: {
            isDelete: { $ne: true },
            commodity: this.record.objectId,
            gift: {
              // 不为空
              $exists: true
            }
          }
        }
      })
      console.log(res.results)
      if (res.results.length === 0) {
        return
      }
      // 循环给dataRegion赋值
      res.results.forEach(item => {
        let obj = JSON.parse(JSON.stringify(this.regionObj))
        obj.agent = item.winWinMerchant.objectId
        obj.agentData = item.winWinMerchant
        obj.gift = item.gift.objectId
        obj.giftData = item.gift
        obj.image = item.gift.image
        obj.costPrice = item.gift.costPrice
        obj.price = item.gift.price
        obj.mainImage = item.mainImage
        obj.pinkage = item.pinkage
        obj.deadline = item.deadline
        this.dataRegion.push(obj)
      })
      // 深拷贝给cacheData赋值
      this.cacheData = JSON.parse(JSON.stringify(this.dataRegion))
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep{
    .ant-select{
      width: 100% !important;
    }
    .upLoad{
      .image-input-wrap{
        width: 100%;
      }
      .empty{
        span{
          display: none;
        }
      }
    }
  }
</style>
